import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../packages/auth-client';
import { Spinner } from '../packages/ui';
import { loginPathFor } from '../utils/returnTo';

/**
 * ProtectedRoute wraps a group of routes and redirects to /login
 * if the user is not authenticated, carrying the requested path + query +
 * hash as ?returnTo= (a Stripe return to /billing?checkout= must survive
 * sign-in). Shows a loading spinner during
 * the initial token validation.
 */
export function ProtectedRoute() {
    const { isAuthenticated, isLoading } = useAuth();
    const { pathname, search, hash } = useLocation();

    if (isLoading) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <Spinner size="lg" />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to={loginPathFor(pathname + search + hash)} replace />;
    }

    return <Outlet />;
}
